import { render, staticRenderFns } from "./CourseCards.vue?vue&type=template&id=95b3029e&scoped=true"
import script from "./CourseCards.vue?vue&type=script&lang=js"
export * from "./CourseCards.vue?vue&type=script&lang=js"
import style0 from "./CourseCards.vue?vue&type=style&index=0&id=95b3029e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95b3029e",
  null
  
)

export default component.exports